import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import styles from './App.module.scss';

import ScrollToTop from './components/ScrollToTop/ScrollToTop';

import Navigation from "./layout/Navigation/Navigation";

import HomePage from './pages/home/index';

import ElementsPage from "./pages/platforms/elements";
import PlayspacePage from "./pages/platforms/playspace";
import AdServerPage from "./pages/platforms/adserver";
import AdvertisersPage from "./pages/platforms/advertisers";
import AutomatedContentPage from "./pages/platforms/automatedContent";

import PressPage from './pages/news-and-views/press';
import PressArticlePage from './pages/news-and-views/press/pages/press-article';
import BlogPage from './pages/news-and-views/blog';
import ArticlePage from './pages/news-and-views/blog/pages/blog-article';
import EventsPage from './pages/news-and-views/events';

import WhoWeArePage from './pages/about-us/who-we-are';
import LeadershipPage from './pages/about-us/leadership';
import CareersPage from './pages/about-us/careers';
import PrivacyPolicyPage from './pages/about-us/privacy-policy';
import Footer from './layout/Footer/Footer';
import LeadershipMemberPage from "./pages/about-us/leadership/pages/leadership-member";
import ContactPage from "./pages/contact";
import BlogArticlePreviewPage
  from "./pages/news-and-views/blog/pages/blog-article/pages/blog-article-preview";
import ManageCookiesPage from "./pages/about-us/privacy-policy/pages/manage-cookies";
import ThankYouPage from "./pages/thank-you";
import NotFoundPage from "./pages/not-found";
import SubProcessorsPage from "./pages/sub-processors";
import CustomCookiesConsent from "./components/CustomCookieConsent/CustomCookiesConsent";
import JobDetails from "./pages/about-us/careers/pages/job-details";

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <CustomCookiesConsent />
        <Navigation />
        <div className={styles['app-container']}>
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route
              exact
              path='/elements'
              render={(props) => <ElementsPage {...props} />}
            />
            <Route
              exact
              path='/playspace'
              render={(props) => <PlayspacePage {...props} />}
            />
            <Route
              exact
              path='/adserver'
              render={(props) => <AdServerPage {...props} />}
            />
            <Route
              exact
              path='/advertisers'
              render={(props) => <AdvertisersPage {...props} />}
            />
            <Route
              exact
              path='/automatedcontent'
              render={(props) => <AutomatedContentPage {...props} />}
            />
            <Route
              exact
              path="/press"
              render={(props) => <PressPage {...props} />}
            />
            <Route
              exact
              path="/events"
              render={(props) => <EventsPage {...props} />}
            />
            <Route
              exact
              path='/blog'
              render={(props) => <BlogPage {...props} />}
            />
            <Route
              exact
              path="/press/:slug"
              render={(props) => <PressArticlePage {...props} />}
            />
            <Route
              exact
              path="/blog/blog-article-preview"
              render={(props) => <BlogArticlePreviewPage {...props} />}
            />
            <Route
              exact
              path='/blog/:slug'
              render={(props) => <ArticlePage {...props} />}
            />
            <Route
              exact
              path="/who-we-are"
              render={(props) => <WhoWeArePage {...props} />}
            />
            <Route
              exact
              path="/leadership"
              render={(props) => <LeadershipPage {...props} />}
            />
            <Route
              exact
              path="/leadership/:slug"
              render={(props) => <LeadershipMemberPage {...props} />}
            />
            <Route
              exact
              path="/careers"
              render={(props) => <CareersPage {...props} />}
            />
            <Route
              exact
              path="/careers/gh_jid=:id"
              render={(props) => <JobDetails {...props} />}
            />
            <Route
              exact
              path="/privacy-policy"
              render={(props) => <PrivacyPolicyPage {...props} />}
            />
            <Route
              exact
              path="/privacy-policy/manage-cookies"
              render={(props) => <ManageCookiesPage {...props} />}
            />
            <Route
              exact
              path="/contact"
              render={(props) => <ContactPage {...props} />}
            />
            <Route
              exact
              path="/thank-you"
              render={(props) => <ThankYouPage {...props} />}
            />
            <Route
              exact
              path="/sub-processors"
              render={(props) => <SubProcessorsPage {...props} />}
            />
            <Route component={NotFoundPage} />
          </Switch>
        </div>
        <Footer />
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default App;
